/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import React from "react";

import { rootStyle } from "./styles";
import { useThis } from "./useThis";

import type { FcWithoutChildren } from "../../../../types/fcWithoutChildren";

export const NoSearchResult: FcWithoutChildren = () => {
  const { text } = useThis();

  return <p css={rootStyle}>{text}</p>;
};
